// PATH: SaberpDeals/frontend/src/lib/customersApi.ts
import { api } from './api';

export interface Customer {
    id: number;
    name: string;
    erpTenantCode: string | null;
    defaultCurrency: 'USD' | 'IQD';
    notes: string | null;
}

export interface CustomerInput {
    name: string;
    erpTenantCode?: string | null;
    defaultCurrency: 'USD' | 'IQD';
    notes?: string | null;
}

export const customersApi = {
    async list(): Promise<Customer[]> {
        const { data } = await api.get('/api/deals/customers');
        return data;
    },
    async create(input: CustomerInput): Promise<Customer> {
        const { data } = await api.post('/api/deals/customers', input);
        return data;
    },
    async update(id: number, input: CustomerInput): Promise<Customer> {
        const { data } = await api.put(`/api/deals/customers/${id}`, input);
        return data;
    },
};
